import { Component } from 'react'
import styled from 'glamorous'
import { withRouter } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { noop, map } from 'lodash'

import { $, span } from 'utils'
import { Icon, ListItem, HeaderRow, ImagePure, Tooltip, FlatButton } from 'components'

import AddListPanel from 'components/panels/AddListPanel'
import AddFacesPanel from 'components/panels/AddFacesPanel'
import AddPersonsPanel from 'components/panels/AddPersonsPanel'

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  background: 'white',
  overflow: 'hidden',
  transform: 'translateX(100%)',
  animation: 'var(--animationSlideIn)',
}, ({ shown }) => !shown && ({
  animation: 'var(--animationSlideOut)',
}), 'cls-container')

const MatchingContainer = styled.div({
  position: 'absolute',
  height: '100%',
  width: '100%',
}, 'cls-matchContainer')

const InnerContainer = styled(PerfectScrollbar)({
  width: '100%',
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '20px 0 75px',
})

const Header = styled.div({
  padding: '0 30px'
})

const MatchDescription = styled.div({
  marginLeft: 30,
  marginTop: 20,
  marginRight: 50,
  height: 35,
  width: 310,
  color: 'var(--grey)',
  textOverflow: 'clip'
})

const MatchLimitContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: 30,
  marginTop: 20,
  marginBottom: 25,
})

const LimitInput = styled.input({
  width: 55,
  height: 34,
  borderRadius: 3,
  margin: '0 12px 0 12px',
  border: '1px solid var(--borderColor)',
  textAlign: 'center'
})

const Blocks = styled.div({
  overflow: 'auto'
})

const BlockContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: 30,
  width: '100%',
  overflow: 'hidden',
  borderBottom: '1px solid var(--borderColor)',
  '&:first-child': {
    borderTop: '1px solid var(--borderColor)'
  }
})

const ListItemDescription = styled.div({
  width: 255,
  color: 'var(--grey)'
})

const ListContainer = styled.div({

})

const PhotoListContainer = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  marginLeft: -2,
  height: '100%'
})

const PhotoContainer = styled.div({
  position: 'relative',
  width: 62,
  height: 80,
  marginLeft: 2,
  marginBottom: 2,
  '&:hover .photo-hover': {
    display: 'flex'
  }
})


class MatchPanel extends Component {

  hintType = this.props.matchType === 'match' ? 'faces' : 'persons'
  hint = `You can ${this.props.matchType} the ${this.props.type} by ${this.hintType} list, or choose ${this.hintType} for matching.`

  state = {
    limit: 3,
    lists: [],
    faces: [],
    persons: [],
    shown: true,
    addMode: undefined,
  }

  static defaultProps = {
    type: 'person', // person | face
    matchType: 'match' // match | identify
  }

  openMatchResults = () => {
    const { history, match, matchType } = this.props
    const listId = this.state.lists.length > 0 ? this.state.lists[0].uuid : undefined
    const descriptors = this.state.faces.length > 0 ? this.state.faces : undefined
    const persons = this.state.persons.length > 0 ? this.state.persons : undefined
    let target, type
    if (matchType === 'match') {
      type = listId ? 'lists' : 'faces'
      target = type === 'lists' ? listId : map(descriptors, p => p.uuid).join(',')
    }
    if (matchType === 'identify') {
      type = listId ? 'lists' : 'persons'
      target = type === 'lists' ? listId : map(persons, p => p.uuid).join(',')
    }
    history.push({
      pathname: `${match.url}/${matchType}/${type}/${target}/${this.state.limit}/`,
    })
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.closePanel() }, 300)
  }

  setAddMode = (mode) => {
    this.setState({ addMode: mode })
  }

  handleSubmit = (type) => (selected) => {
    if (type === 'lists') {
      this.setState({ lists: selected })
    } else if (type === 'faces') {
      this.setState({ faces: selected })
    } else {
      this.setState({ persons: selected })
    }
  }

  selectAllFaces = (faces) => {
    this.setState({ faces })
  }

  clearList = () => this.setState({ lists: [] })
  clearFaces = () => this.setState({ faces: [] })
  clearPersons = () => this.setState({ persons: [] })
  handleChangeLimit = ({ target }) => this.setState({ limit: target.value })

  render = () => {
    const { addMode, lists, faces, persons, shown } = this.state
    const { matchType } = this.props
    return (
      $(Container, { shown },
        $(this.renderMatching),
        addMode === 'lists' && $(AddListPanel, {
          type: matchType === 'match' ? 'descriptors' : 'persons',
          onClose: () => this.setAddMode(),
          selected: lists,
          single: true,
          onSubmit: this.handleSubmit('lists'),
        }),
        matchType === 'match' &&
          addMode === 'faces' && $(AddFacesPanel, {
            onClose: () => this.setAddMode(),
            selected: faces,
            onSubmit: this.handleSubmit('faces'),
            onSelectAll: this.selectAllFaces,
          }),
        matchType === 'identify' &&
          addMode === 'persons' && $(AddPersonsPanel, {
            selected: persons,
            onClose: () => this.setAddMode(),
            onSubmit: this.handleSubmit('persons'),
          }),
      )
    )
  }

  renderMatching = () => {
    const { matchType } = this.props
    const { limit, lists, faces, persons } = this.state
    const someSelected = lists.length > 0 || faces.length > 0 || persons.length > 0
    const btnText = !someSelected
      ? 'Nothing selected'
      : lists.length > 0
        ? (lists.length === 1 ? `by list ${lists[0].uuid}` : `by (${lists.length}) lists`)
          : faces.length > 0
            ? (faces.length === 1 ? `by face ${faces[0].uuid}` : `by (${faces.length}) faces`)
            : (persons.length === 1 ? `by person ${persons[0].uuid}` : `by (${persons.length}) persons`)

    return (
      $(MatchingContainer,
        $(InnerContainer,
          $(Header,
            $(HeaderRow, {
              label: matchType === 'match' ? 'Matching' : 'Identifying',
              onLabelClick: this.close,
              clickable: true,
              withArrow: true
            }),
          ),
          $(MatchDescription, this.hint),
          $(MatchLimitContainer,
            span('Limit'),
            $(LimitInput, { type: 'text', value: limit, onChange: this.handleChangeLimit }),
            span('best results')
          ),
          $(Blocks,
            $(BlockContainer,
              $(HeaderRow, { label: `By ${this.hintType} lists`},
                lists.length > 0 &&
                  $(Tooltip, { tip: 'Clear the list', position: 'bottom' },
                    $(Icon, { type: 'delete', onClick: this.clearList })
                  ),
                $(Tooltip, { tip: 'Add lists' },
                  $(Icon, {
                    type: 'add',
                    isDisabled: faces.length > 0 || persons.length > 0,
                    onClick: () => this.setAddMode('lists'),
                  })
                )
              ),
              lists.length > 0 ? $(ListContainer, lists.map((faceList, key) =>
                $(ListItem, {
                  key,
                  last: key === lists.length - 1,
                  name: faceList.listData,
                  value: faceList.uuid
                })
              )) : $(ListItemDescription, this.hint)
            ),
            matchType === 'match' &&
              $(BlockContainer,
                $(HeaderRow, { label: 'By faces'},
                  faces.length > 0 &&
                  $(Tooltip, { tip: 'Clear the list', position: 'bottom' },
                    $(Icon, { type: 'delete', onClick: this.clearFaces })
                  ),
                  $(Tooltip, { tip: 'Add faces' },
                    $(Icon, {
                      type: 'add',
                      isDisabled: lists.length > 0 || persons.length > 0,
                      onClick: () => this.setAddMode('faces')
                    })
                  )
                ),
                faces.length > 0
                  ? $(PhotoListContainer, faces.map((face, key) =>
                      $(PhotoContainer, { key },
                        $(ImagePure, {
                          src: face.portrait,
                          width: 62,
                          height: 80
                        }),
                      )
                  ))
                  : $(ListItemDescription, this.hint)
              ),
            matchType === 'identify' &&
              $(BlockContainer,
                $(HeaderRow, { label: 'By persons'},
                  persons.length > 0 &&
                    $(Tooltip, { tip: 'Clear the list', position: 'bottom' },
                      $(Icon, { type: 'delete', onClick: this.clearPersons })
                    ),
                  $(Tooltip, { tip: 'Add persons' },
                    $(Icon, {
                      type: 'add',
                      isDisabled: lists.length > 0 || faces.length > 0,
                      onClick: () => this.setAddMode('persons')
                    })
                  )
                ),
                persons.length > 0
                  ? $(PhotoListContainer, persons.map((person, key) =>
                      $(PhotoContainer, { key },
                        $(ImagePure, {
                          src: person.portrait,
                          width: 62,
                          height: 80
                        }),
                      )
                  ))
                  : $(ListItemDescription, this.hint)
              ),
          ),
        ),
        $(FlatButton, {
            onClick: someSelected ? this.openMatchResults : noop,
            disabled: !someSelected,
            text: matchType === 'match' ? 'Match' : 'Identify',
            valueText: btnText
          }
        )
      )
    )
  }
}

export default withRouter(MatchPanel)


// WEBPACK FOOTER //
// ./src/components/panels/MatchPanel.js